import BaseAction from './BaseAction.js';
import Track from 'track/Track.js';
import MoveStepsAction from './moveStepsAction.js';

class SnapToGridAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({track, steps, resolution=Track.baseResolution}, updateRedux=true) {
        let pattern = track.getEasyPattern();

        // need to keep track of where the step was: i.e.
        // the stepNumber AND position (so that we may undo, beloved)
        let stepNumbers = pattern.getStepNumbers(steps, resolution);
        for (let i in stepNumbers) {
            let step = stepNumbers[i][0];
            if (!step) {
                continue;
            }
            stepNumbers[i][1] = stepNumbers[i][1] + step.position;
            stepNumbers[i][0] = step.id;
        }
        let oldStepLocations = this.getStepLocations(pattern, steps, true);
        pattern.snapToGrid(steps, resolution);
        let newStepLocations = this.getStepLocations(pattern, steps, false);
        for (let i in newStepLocations) {
            newStepLocations[i].stepDifference =
                newStepLocations[i].stepNumber - oldStepLocations[i].stepNumber;
            newStepLocations[i].transposeDifference =
                newStepLocations[i].transpose - oldStepLocations[i].transpose;
        }
        if (updateRedux) {
            if (resolution.isTriplet) {
                track.updateSteps(undefined, undefined, true);
            } else {
                track.updateSteps();
            }
        }

        return {
            stepNumbers,
            stepLocations: newStepLocations
        };
    }

    undo({payload}) {
        let {stepNumbers, steps, track, resolution} = payload;
        
        let pattern = track.getEasyPattern();
        let newStepNumbers = pattern.getStepNumbers(steps, resolution);

        let moveStepsAction = new MoveStepsAction(this.sequencerEngine);
        for (let i in newStepNumbers) {
            let newStepNumber = newStepNumbers[i][1];
            let oldStepNumber = stepNumbers[i][1];
            let step = steps[i];
            let transformation = {
                stepDifference: oldStepNumber - newStepNumber,
                transposeDifference: 0
            };
            moveStepsAction.execute({
                track,
                steps,
                transformation,
                resolution
            });
        }
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        operation.payload.steps = operation.payload.steps
            .map(x => x.getJson());
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let payload = action.payload;
        let track = payload.track;
        if (track === undefined) {
            return undefined;
        }

        // given these we need to find the steps that match these numbers
        let steps = payload.steps.map(
            (stepData) =>
                this.deserializeStep(stepData, track, stepData.stepNumber),
                );
        payload.steps = this.getStepsForStepNumbers(steps, track, Track.baseResolution);
        return action;
    }

    getContentId({payload}) {
        return payload.steps.map(s => s.id);
    }
}

export default SnapToGridAction;
